export default "__VITE_ASSET__edcee9da__"